import React, { lazy, Suspense, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loader, { LoaderScreen } from "../components/Loader";
import Context from "../context/AppContext";

const VideoPlayer = lazy(() => import("../components/VideoPlayer"));

function WatchAnime() {
  const { episode } = useParams();
  const { capitules, navigation, setNavigation, setCapitule, capitule, anime } =
    useContext(Context);

  useEffect(() => {
    if (navigation) setNavigation(false);
    if (!capitules) throw new Error("Ptmn no tiene nada de capitules");
    const cap = capitules?.find(({ number }) => number === parseInt(episode));
    setCapitule(cap);
  }, [capitules]);

  /* url={capitule.video} header={capitule.video_headers}  props from video player before shit 💩*/

  return (
    <>
      <Suspense
        fallback={
          <LoaderScreen>
            <Loader />
          </LoaderScreen>
        }
      >
        <VideoPlayer
          videoUrl={"https://kowxv.vizcloud2.online/simple/EqPFI_8QBAro1HhYl67rC5UuqlwHubroFwN7rqk+wYMnU94US2El/br/list.m3u8"}
          capitule={capitule}
          anime={anime}
        />
      </Suspense>
    </>
  );
}

export default WatchAnime;
